import axios from 'axios';

// export default {
// 	axiosInstance: axios.create({
// 		baseURL: process.env.VUE_APP_API_ENDPOINT
// 	})
// };
export default axios.create({baseURL: process.env.VUE_APP_API_ENDPOINT});
